export const ColorSorter = {
    methods: {
        /**
         * Permet de convertir une partie d'un code couleur au format hexa en code couleur au format decimal
         *
         * @param {string} hexa - ex : "#73E25D"
         * @returns {string} - Partie de couleur au format décimal
         */
        hexaToDec(hexa) {
            return parseInt((hexa + '').replace(/[^a-f0-9]/gi, ''), 16);
        },

        /**
         * Permet de convertir la totalité d'un code couleur au format hexa en code couleur au format decimal
         *
         * @param {string} hexa - ex : "#73E25D"
         * @returns {string} - Couleur au format décimal
         */
        hexaBrightness(hexa) {
            const conversion = [0.299, 0.587, 0.114]; //BT601

            return (this.hexaToDec(hexa[0] + hexa[1]) * conversion[0] + this.hexaToDec(hexa[2] + hexa[3]) * conversion[1] + this.hexaToDec(hexa[4] + hexa[5]) * conversion[2]);
        },

        /**
         * Permet de déterminer la couleur la plus brillante
         *
         * @param {Array} colors - ex : [{name: "rouge", code: "#E25D6D", isChecked: "true"},
         *                               {name: "bleu", code: "#5D6FE2", isChecked: "false"},
         *                               {name: "vert", code: "#73E25D", isChecked: "false"}]
         * @returns {string} mostBrightColor - Couleur la plus brillante
         */
        mostBrightColor(colors) {
            let mostBright = "";
            let hexaColor = "";
            let mostBrightColor = "";

            colors.forEach((color) => {
                hexaColor = color.code;

                if (!mostBright || this.hexaBrightness(hexaColor) > this.hexaBrightness(mostBright)) {
                    mostBright = hexaColor;
                    mostBrightColor = color;
                }
            });

            return mostBrightColor;
        },

        /**
         * Permet de trier des couleurs par brillance (#000000 => #FFFFFF)
         *
         * @param {Array} colors - ex : [{name: "rouge", code: "#E25D6D", isChecked: "true"},
         *                               {name: "bleu", code: "#5D6FE2", isChecked: "false"},
         *                               {name: "vert", code: "#73E25D", isChecked: "false"}]
         * @returns {Array} sortedColors - Couleurs triées
         */
        sortColors(colors) {
            const colorsCopy = colors.slice(0);
            const sortedColors = [];

            // On parcourt les couleurs et on alimente au fur et à mesure un tableau de couleurs triées
            while (colorsCopy.length > 0) {
                const color = this.mostBrightColor(colorsCopy);
                let colorIndex = colorsCopy.indexOf(color);
                if (colorIndex > -1) {
                    colorsCopy.splice(colorIndex, 1);
                }
                sortedColors.push(color)
            }

            return sortedColors
        }
    }
}
